<template>
  <ContactForm />
</template>

<script>
import ContactForm from "@/components/widgets/ContactForm.vue";

export default {
  name: "HomeContact",
  components: { ContactForm },
};
</script>

<style scoped></style>
